<template>

    <LoadingDiv v-if="!isReady" />

    <template v-else>
        <div class="section saved-claim-shell sba-slide-in" v-for="cluster in clusters" :key="cluster.id">
            <div class="card z-depth-0 grey lighten-4 saved-claim-card">
                <br />
                <span class="new badge teal darken-2 left" data-badge-caption="Scheme">{{
                    cluster.scheme.name.toUpperCase()
                }}</span>

                <div class="card-content">
                    <div class="row">
                        <div class="col s8">
                            <p>{{ displayMonthYear(cluster.month_year) }}</p>
                            <h5>{{ capWords(cluster.provider.name) }}</h5>
                            <h6>
                                <i class="tiny material-icons">save</i> {{ cluster.encounters.length }} Claims
                            </h6>
                        </div>
                        <div class="col s4">
                            <img alt="" :src="user.profile_img" width="128" class="circle responsive-img right"
                                :title="user.name" v-if="user.profile_img" />
                            <img alt="" :src="`https://ui-avatars.com/api/?name=${user.name}&background=random&size=128`"
                                width="128" class="circle responsive-img right" :title="user.name" v-else />
                        </div>
                    </div>
                </div>

                <div class="row teal lighten-5">
                    <div class="col s12 m8">
                        <span class="chip">Last <em>Saved</em> on
                            {{
                                new Date(cluster.updated_at).toLocaleString(undefined, {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })
                            }}
                        </span>
                    </div>
                    <div class="col s12 m4">
                        <a class="waves-effect waves-light btn-large col s12 m9 right" :class="{ 'disabled': savedCluster }"
                            @click.prevent="handleReStart(cluster)"><i class="material-icons disable left">send</i>
                            Continue</a>
                            <!-- Breaker -->
                           <span class="co1 m3"></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="section center saved-claim-empty" v-if="!clusters?.length">
            <h6>No <em>(Saved)</em> Claims <em>found</em>...</h6>
        </div>
    </template>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import getItems from "@/composables/getItems";
import { capWordsFx, } from "@/composables/fxLibrary/coreFx";
import { getClusterMonthYear, getFullMonthName } from "@/composables/fxLibrary/months";
import LoadingDiv from "@/components/LoadingDiv.vue";

export default {
    name: "savedClaimUser",
    components: { LoadingDiv },
    emits: ["restart"],
    setup(props, context) {
        const isReady = ref(false);
        const isLoading = ref(false);
        const response = ref(null);
        const error = ref(null);

        // store
        const store = useStore();

        // get function
        const getItemsFromApi = (table) => {

            (async () => {
                const { res, err } = await getItems(table);

                if (res.value) {
                    response.value = res.value.data;
                } else {
                    error.value = err.value;
                }

                isReady.value = true;
                isLoading.value = false;
            })();
        };

        // start
        onMounted(() => {
            // params u=user_id, s=scope, c=cluster_id
            let queryVal = `u=${store.state.user.id}&s=user&c=`;
            // Saved by User
            getItemsFromApi(`cluster/hmo/saved?${queryVal}`);
        });

        //from functions
        const capWords = (val) => {
            return capWordsFx(val);
        };

        // display mont year
        const displayMonthYear = (val) => {
            return getClusterMonthYear(val);
        }

        // restart
        const handleReStart = async (val) => {

            // loading
            isReady.value = false;

            // params u=user_id, s=scope, c=cluster_id
            let queryVal = `u=${store.state.user.id}&s=""&c=${val.id}`;

            // Saved by cluster
            const { res, err } = await getItems(`cluster/hmo/saved?${queryVal}`);

            if (res.value) {
                // reload cluster
                let restartcluster = { ...res.value.data[0] }; // ...val

                // convert month_year
                let monthYear = restartcluster.month_year.split("_");
                // month
                restartcluster.month = { search: Number(monthYear[0]), name: getFullMonthName(monthYear[0] - 1) };
                // year
                restartcluster.year = { search: Number(monthYear[1]), name: monthYear[1] };

                // uptimize claims
                restartcluster.encounters.forEach((encounter) => {
                    encounter.claims.forEach((claim) => {
                        claim.claim = claim.item
                        claim.qty = claim.sent_qty
                        claim.amt = claim.sent_price
                        claim.standard = claim.standard_price
                    })
                })

                // save payload
                store.commit("loadCluster", restartcluster);

                // restart
                context.emit("restart", true);

            } else {
                error.value = err.value;
            }

            // end 
            isReady.value = true;
        }

        // output results
        const clusters = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value;
            }
        });


        return {
            handleReStart,
            user: store.state.user,
            savedCluster: store.state.cluster,
            displayMonthYear,
            capWords,
            isReady,
            isLoading,
            response,
            error,
            clusters,
        };
    },
};
</script>

<style scoped>
.saved-claim-card,
.saved-claim-empty {
    animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.custom-hr {
    width: 50%;
    border: none;
    border-top: 2px solid #ccc;
    margin: 20px 20px;
}

@media (prefers-reduced-motion: reduce) {
    .saved-claim-card,
    .saved-claim-empty {
        animation: none;
    }
}
</style>
